exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".border-hearder[data-v-35d65550]{border-color:#dfe6ec!important;margin-top:-1px}.pdfIcon[data-v-35d65550]{width:50px;height:50px}.evidence-Dropdown[data-v-35d65550]{width:192px}.bg-lightgary[data-v-35d65550]{background:#eef1f6;border:1px solid #e6e6e6}.bg-lightgary table tr td[data-v-35d65550]:first-child{display:list-item;margin-left:15px;margin-top:4px}.bg-lightgary table td[data-v-35d65550]{color:#000}.bg-lightgary table td span[data-v-35d65550]{background:#e6e6e6;display:inline-block;padding:2px 5px;margin:2px 10px 0 0;color:#324157;font-weight:400!important}.bg-lightgary table td span span[data-v-35d65550]{color:#ff4949;margin:0;padding:0}.p-5[data-v-35d65550]{padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-35d65550","scoped":true,"hasInlineConfig":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/student/Evidence.vue
// module id = 533
// module chunks = 1